import { LayoutEditorContextType } from '../../types/context';
import { LAYOUT_EDITOR_EMPTY_CANVAS } from '../../constants';

// Context value outside a LayoutEditorProvider: every action throws so a
// misplaced consumer fails loudly instead of silently no-oping.
export const defaultValues: LayoutEditorContextType = {
  isProvided: false,
  definition: undefined,
  layout: undefined,
  isLoading: false,
  error: undefined,
  isSaving: false,
  canvas: LAYOUT_EDITOR_EMPTY_CANVAS,
  objects: [],
  selectedIndex: null,
  isDirty: false,
  isFixedMode: false,
  saveErrors: [],
  saveErrorsVersion: 0,
  isMatrixSupported: false,
  isMatrixDialogOpen: false,
  matrixFormData: null,
  focusedObjectField: null,
  fullscreenReference: null,
  selectObject: () => {
    throw new Error('selectObject must be implemented');
  },
  updateObject: () => {
    throw new Error('updateObject must be implemented');
  },
  addObject: () => {
    throw new Error('addObject must be implemented');
  },
  removeObject: () => {
    throw new Error('removeObject must be implemented');
  },
  moveObject: () => {
    throw new Error('moveObject must be implemented');
  },
  copySelectedObject: () => {
    throw new Error('copySelectedObject must be implemented');
  },
  pasteObject: () => {
    throw new Error('pasteObject must be implemented');
  },
  isObjectCopied: () => {
    throw new Error('isObjectCopied must be implemented');
  },
  clearCopiedObjectMark: () => {
    throw new Error('clearCopiedObjectMark must be implemented');
  },
  patchCanvas: () => {
    throw new Error('patchCanvas must be implemented');
  },
  applyObjectDefault: () => {
    throw new Error('applyObjectDefault must be implemented');
  },
  applyCanvasDefault: () => {
    throw new Error('applyCanvasDefault must be implemented');
  },
  saveLayout: () => {
    throw new Error('saveLayout must be implemented');
  },
  reset: () => {
    throw new Error('reset must be implemented');
  },
  fetchMatrixDefaults: () => {
    throw new Error('fetchMatrixDefaults must be implemented');
  },
  generateMatrix: () => {
    throw new Error('generateMatrix must be implemented');
  },
  openMatrixDialog: () => {
    throw new Error('openMatrixDialog must be implemented');
  },
  closeMatrixDialog: () => {
    throw new Error('closeMatrixDialog must be implemented');
  },
  seedMatrixFormData: () => {
    throw new Error('seedMatrixFormData must be implemented');
  },
  patchMatrixFormData: () => {
    throw new Error('patchMatrixFormData must be implemented');
  },
  openFullscreenReference: () => {
    throw new Error('openFullscreenReference must be implemented');
  },
  closeFullscreenReference: () => {
    throw new Error('closeFullscreenReference must be implemented');
  },
  submitFullscreenReference: () => {
    throw new Error('submitFullscreenReference must be implemented');
  },
  isCanvasFieldDirty: () => {
    throw new Error('isCanvasFieldDirty must be implemented');
  },
  isObjectFieldDirty: () => {
    throw new Error('isObjectFieldDirty must be implemented');
  },
  isObjectDirty: () => {
    throw new Error('isObjectDirty must be implemented');
  },
  isObjectNew: () => {
    throw new Error('isObjectNew must be implemented');
  },
  setFocusedObjectField: () => {
    throw new Error('setFocusedObjectField must be implemented');
  },
};
